import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { v4 as uuid } from "uuid";
import { formatNumberInText } from "../../utils";
import { priceDisplayFormat } from "../../utils/priceUtils";
import { intlShape, planCartShape, userShape } from "../../shapes";
import PlanVariantAddonsGroup from "./PlanVariantAddonsGroup";
import { withConfiguration } from "../../context";
import { withUser } from "../../wrappers";

type Props = {
  planVariant?: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string;
    type?: string;
    sort?: number;
    popular?: boolean;
    button?: string;
    assets?: number;
    storage?: number;
    short_description?: string;
    features?: string[];
    addons?: $TSFixMe[];
  };
  planCart?: planCartShape;
  intl: intlShape;
  onSelect: $TSFixMeFunction;
  disabled?: boolean;
  creating?: boolean;
  configuration?: {
    planPriceDisplay?: string;
  };
  user: userShape;
};

type State = $TSFixMe;

export class PlanVariant extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.onAddonChange = this.onAddonChange.bind(this);
    this.handleMouseClick = this.handleMouseClick.bind(this);
    this.state = {
      addons: {},
      total: 0,
    };
  }

  componentDidMount() {
    this.setState({ total: this.calculateTotal() });
  }

  handleMouseClick(planVariant: $TSFixMe) {
    const { onSelect } = this.props;
    onSelect(planVariant, this.state.addons);
  }

  onAddonChange(value: $TSFixMe, addon: $TSFixMe) {
    const tmpAddons = this.state.addons;
    const addons = { ...tmpAddons };
    addons[addon.id] = value;
    this.setState({
      addons,
      total: this.calculateTotal(this.props.planVariant, addons),
    });
  }

  calculateTotal(plan = this.props.planVariant, addons = this.state.addons) {
    let total = plan?.price ? parseFloat(plan.price) : 0.0;
    Object.keys(addons).forEach((addonId) => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const planVariantAddon = plan.addons.find(
        (addon) => addon.id === addonId,
      );
      total += parseFloat(planVariantAddon.price) * addons[addonId];
    });
    return total;
  }

  render() {
    const {
      planVariant,
      planCart,
      disabled,
      creating,
      intl,
      configuration,
      user,
    } = this.props;
    const { total } = this.state;

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const panelClass = planVariant.popular
      ? "panel panel-primary"
      : "panel panel-default";
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const buttonClass = planVariant.popular
      ? "btn btn-primary select-button"
      : "btn select-button";
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const planVariantPrice = parseFloat(planVariant.price);
    const planPriceDisplayYearly = configuration?.planPriceDisplay === "yearly";
    const planUnitText = intl.formatMessage({ id: "planvariant.per_user" });

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const features = planVariant.features.map((item) => (
      <li className="list-item-checked" key={uuid()}>
        {formatNumberInText(item)}
      </li>
    ));
    const displayPrice = priceDisplayFormat(
      intl,
      planVariantPrice,
      planPriceDisplayYearly,
      planVariant?.currency,
      planUnitText,
    );
    let price;
    if (
      planVariant?.name &&
      planVariant.name.toLowerCase().includes("fermentation")
    ) {
      const yearlyPrice = parseFloat(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        planVariant.addons.find((addon) => addon.type === "connectivity")
          ?.price,
      );
      const fermentationUnitText = intl.formatMessage({
        id: "planvariant.per_qwx43",
      });
      price = priceDisplayFormat(
        intl,
        yearlyPrice,
        planPriceDisplayYearly,
        planVariant?.currency,
        fermentationUnitText,
      );
    } else {
      price =
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        planVariant.type === "free" || planVariantPrice === 0
          ? intl.formatMessage({ id: "planvariant.free" })
          : displayPrice;
    }

    const planVariantName = planVariant?.name || "";
    const connectivtyAddonsMinAmount = planVariantName
      .toLowerCase()
      .includes("fermentation")
      ? 1
      : 0;
    const totalPrice = priceDisplayFormat(
      intl,
      total,
      planPriceDisplayYearly,
      planVariant?.currency,
      undefined,
    );
    const totalRendered = (
      <div className="plan-variant-total">
        <div className="plan-variant-total-header">
          <FormattedMessage id="planvariant.total" />
        </div>
        <div className="plan-variant-total-value">{totalPrice}</div>
        <div className="plan-variant-total-value-note">
          <FormattedMessage id="planvariant.billed_annually" />
        </div>
      </div>
    );

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const shortDescription = planVariant.short_description ? (
      <div id="short-description" className="space-after short-description">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {planVariant.short_description}
      </div>
    ) : null;

    const spinner = creating ? <i className="btn-spinner" /> : null;
    const addonKey =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      planVariant.currency === "USD"
        ? "fermentation-monitor-connected-asset-usd"
        : "fermentation-monitor-connected-asset";
    const submitDisabledForFermentation =
      planVariant?.name?.toLowerCase().includes("fermentation") &&
      (!this.state.addons[addonKey] || this.state.addons[addonKey] < 1);

    return (
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      <div id={`plan-variant-${planVariant.id}`} className={panelClass}>
        <div className="panel-heading">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {planVariant.name}
          <div id="price" className="panel-heading panel-subtitle">
            {price}
          </div>
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {planVariant.type === "free" || planVariantPrice === 0 ? null : (
            <p className="panel-subtitle">
              {intl.formatMessage({ id: "planvariant.billed_annually" })}
            </p>
          )}
        </div>
        <div className="panel-body">
          {shortDescription}
          <ul id="plan-variant-features" className="list-checked">
            {features}
          </ul>
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            planCart={planCart}
            user={user}
            types={["outcome"]}
            groupId="outcome"
            titleId="planvariant.outcome"
            onAddonChange={this.onAddonChange}
            disabled={disabled}
            intl={intl}
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            planCart={planCart}
            minAmount={connectivtyAddonsMinAmount}
            user={user}
            types={["connectivity"]}
            groupId="connectivity"
            titleId="planvariant.connectivity"
            onAddonChange={this.onAddonChange}
            disabled={disabled}
            intl={intl}
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            planCart={planCart}
            user={user}
            types={["process_insights"]}
            groupId="process-insights"
            titleId="planvariant.process_insights"
            onAddonChange={this.onAddonChange}
            disabled={disabled}
            intl={intl}
          />
          <PlanVariantAddonsGroup
            planVariant={planVariant}
            planCart={planCart}
            user={user}
            types={["addon", "extension"]}
            groupId="standard"
            titleId="planvariant.addons"
            onAddonChange={this.onAddonChange}
            disabled={disabled}
            intl={intl}
          />
          <div>{totalRendered}</div>
        </div>
        <div className="panel-footer">
          <button
            type="button"
            disabled={disabled || submitDisabledForFermentation}
            onMouseDown={() => this.handleMouseClick(planVariant)}
            className={buttonClass}
          >
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {planVariant.button}
            {spinner}
          </button>
        </div>
      </div>
    );
  }
}

export default injectIntl(withConfiguration(withUser(PlanVariant)));
